import {defaultState} from '../state';
import * as UIActions from '../../actions/UIActions';
import {COUNTRIES} from '../../constants/AppConstants';
import {CURRENT_CHECKED, CHECKED, DISABLED} from '../../constants/StepConstants';
const mapMenu = (steps, totalSteps) =>
    steps.map(item => ({
        ...item,
        percentage: Math.floor((parseInt(item.id, 0) + 1) * 100 / totalSteps)
    }));

const checkMenuSelected = (steps = [], actionHighStep, actionStep) => steps.map((item) => {
    const stepId = parseInt(item.id, 10);
    let selectedStatus = DISABLED;
    if (stepId <= actionHighStep) {
        selectedStatus = CHECKED;
    }
    if (stepId === actionStep) {
        selectedStatus = CURRENT_CHECKED;
    }
    return {
        ...item,
        selected: selectedStatus,
    };
});

const stepView = (state = defaultState.ui.stepView, action) => {
    const country = COUNTRIES[action.country];
    const totalSteps = country ? country.steps.length : 0;
    switch (action.type) {
        case UIActions.INIT_APP_ACTION.name:
            return {
                ...state,
                steps: mapMenu(country.steps, totalSteps),
                mainStep: mapMenu(country.mainStep, totalSteps),
            };
        case UIActions.ON_SELECTED_STEP_ACTION.name:
            const actionStep = parseInt(action.step, 10);
            const actionHighStep = parseInt(action.highestStep, 10);
            return {
                ...state,
                steps: checkMenuSelected(state.steps, actionHighStep, actionStep),
                mainStep: checkMenuSelected(state.mainStep, actionHighStep, actionStep)
            };
        default:
            return state;
    }
};

export default stepView;